import { Box, CircularProgress } from "@mui/material";

export default function LoadingComponent() {

    return (
        <Box sx={{
            height: '80vh',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }}>
            <CircularProgress color="secondary" />
        </Box>
    )
}